import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AccountSettingsCard = ({ user, userProfile, subscription }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
      <div className="flex items-center space-x-3 mb-6">
        <div className="p-2 bg-primary/10 rounded-lg">
          <Icon name="Settings" size={20} className="text-primary" />
        </div>
        <h3 className="text-lg font-semibold text-foreground">Account Settings</h3>
      </div>
      <div className="space-y-4">
        <div className="flex items-center justify-between p-4 bg-muted/30 rounded-lg">
          <div className="flex items-center space-x-3">
            <Icon name="Mail" size={18} className="text-muted-foreground" />
            <div>
              <p className="text-sm font-medium text-foreground">Email Address</p>
              <p className="text-xs text-muted-foreground">{user?.email || 'Not set'}</p>
            </div>
          </div>
          <Button variant="ghost" size="sm" onClick={() => window?.location?.assign('/profile-settings')}>Edit</Button>
        </div>
        <div className="flex items-center justify-between p-4 bg-muted/30 rounded-lg">
          <div className="flex items-center space-x-3">
            <Icon name="User" size={18} className="text-muted-foreground" />
            <div>
              <p className="text-sm font-medium text-foreground">Profile</p>
              <p className="text-xs text-muted-foreground">{userProfile?.full_name || userProfile?.first_name || 'Not set'}</p>
            </div>
          </div>
          <Button variant="ghost" size="sm" onClick={() => window?.location?.assign('/profile-settings')}>Edit</Button>
        </div>
        <div className="flex items-center justify-between p-4 bg-muted/30 rounded-lg">
          <div className="flex items-center space-x-3">
            <Icon name="Shield" size={18} className="text-muted-foreground" />
            <div>
              <p className="text-sm font-medium text-foreground">Security</p>
              <p className="text-xs text-muted-foreground">Password and 2FA settings</p>
            </div>
          </div>
          <Button variant="ghost" size="sm" onClick={() => window?.location?.assign('/profile-settings')}>Manage</Button>
        </div>
      </div>
    </div>
  );
};

export default AccountSettingsCard;